import React from "react";
import sqlFormatter from "sql-formatter";
import style from "./Modal.module.scss";

const reservedWords = [
  "SELECT",
  "FROM",
  "WHERE",
  " AND ",
  " OR ",
  " IN ",
  "ORDER BY",
  "GROUP BY",
  " JOIN ",
  " INNER JOIN ",
  " LEFT JOIN ",
  " RIGHT JOIN ",
  "DECLARE",
  "SET",
];

function parseSQLReservedWords(_query) {
  const query = sqlFormatter.format(_query);
  const regex = new RegExp(reservedWords.join("|"), "gi");

  let nodes = query.split(/\r?\n/);

  let elements = [];

  nodes.forEach((_node) => {
    const node = _node + "\n";
    const matches = node.matchAll(regex);
    let chunksToHighlight = [];
    for (const match of matches) {
      chunksToHighlight.push({
        start: match.index,
        end: match.index + match[0].length,
      });
    }
    elements.push(...fillInChunks({ chunksToHighlight, text: node }));
  });

  return elements;
}

const fillInChunks = ({ chunksToHighlight, text }) => {
  const allChunks = [];
  const append = (start, end, highlight) => {
    if (end - start > 0) {
      allChunks.push({
        start,
        text: text.substring(start, end),
        highlight,
      });
    }
  };

  if (chunksToHighlight.length === 0) {
    append(0, text.length, false);
  } else {
    let lastIndex = 0;
    chunksToHighlight.forEach((chunk) => {
      append(lastIndex, chunk.start, false);
      append(chunk.start, chunk.end, true);
      lastIndex = chunk.end;
    });
    append(lastIndex, text.length, false);
  }
  return allChunks;
};

const FormattedSQL = ({ query }) => {
  return (
    <span>
      {parseSQLReservedWords(query).map((e, i) => (
        <span key={i} className={e.highlight ? style.highlightWord : null}>
          {e.text}
        </span>
      ))}
    </span>
  );
};

export default FormattedSQL;
